import { css } from 'glamor'

export default {
  score: css({
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'column',
    paddingBottom: '5px',
    marginBottom: '10px',
    borderBottom: '2px solid #ccc',

    '@media(min-width: 330px)': {
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
  parameterWrapper: css({
    flex: 1,
  }),
  coins: css({
    marginBottom: '10px',

    '@media(min-width: 330px)': {
      marginBottom: '0',
    },
  }),
  parameter: css({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    left: '0',

    '@media(min-width: 700px)': {
      left: '70px',
    },
  }),
  images: css({

  }),
  image: css({
    margin: '0 5px',
  }),
  coin: css({
    width: '15px',

    '@media(min-width: 530px)': {
      width: '25px',
    },
  }),
  man: css({
    width: '10px',

    '@media(min-width: 530px)': {
      width: '20px',
    },
  }),
}



// WEBPACK FOOTER //
// ./src/components/Score/styles.js